import React from 'react';
import Flex from '@wix/da-ds/pkg/Flex';

export interface MultiAttachmentPreviewHeaderProps {
  className?: string;
  leading: React.ReactNode;
  trailing: React.ReactNode;
}

const MultiAttachmentPreviewHeader: React.FC<MultiAttachmentPreviewHeaderProps> = ({
  className,
  leading,
  trailing,
}) => (
  <div className={className}>
    <Flex direction="row" justifyContent="space-between" alignItems="center" fullHeight>
      {leading}
      {trailing}
    </Flex>
  </div>
);
MultiAttachmentPreviewHeader.displayName = 'MultiAttachmentPreviewHeader';

export default MultiAttachmentPreviewHeader;
